import * as antd from "antd";

export const MainTitle = ({ children }: { children: React.ReactNode }) => (
  <antd.Typography.Title level={3}>{children}</antd.Typography.Title>
);

export const Subtitle = ({ children }: { children: React.ReactNode }) => (
  <antd.Typography.Title level={5}>{children}</antd.Typography.Title>
);
